export default __webpack_public_path__ + "static/luxurydaily-5b3327b62d977b2c733d6d84fd2be63a.png";